import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import styles from "./StaffViewTraining.module.css";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import { InputField, Modal, TextComponent } from "../../../../components";
// import dummyVideo from '../../../../assets/images/dummyVideo.mp4';
const StaffViewTraining = () => {
  const [isModal, setIsModal] = useState(false);
  const [password, setPassword] = useState("");
  const { state } = useLocation();
  // console.log("mediaType==========>>>>>>", mediaType);
  // console.log("locationnnnnnnn====>>>>>>", state?.media?.originFileObj);
  return (
    <div className={styles.mainCont}>
      <HeaderComponent
        heading={state?.title ? state?.title : "Bread Flour Training Video"}
        showBackIcon={true}
        showFilterIcon={false}
        showSubmitButton={false}
        showSearch={false}
      />
      <div className={styles.content}>
        <div className={styles.contentTextDiv}>
          <TextComponent
            className={styles.contentHeading}
            text={"Assign Station"}
          />
          <TextComponent
            className={styles.contentText}
            text={
              state?.assStation?.value
                ? state?.assStation?.value
                : "Mixing, Assembly"
            }
          />
        </div>
        <div className={styles.contentTextDiv}>
          <TextComponent
            className={styles.contentHeading}
            text={"Assign role"}
          />
          <TextComponent
            className={styles.contentText}
            text={state?.tarRole?.value ? state?.tarRole?.value : "Supervisor"}
          />
        </div>
        <div className={styles.contentTextDiv}>
          <TextComponent
            className={styles.contentHeading}
            text={"Tags"}
          />
          <TextComponent
            className={styles.contentText}
            text={state?.tags?.value ? state?.tags?.value : "SOP, Mixing"}
          />
        </div>
        <div className={styles.contentTextDiv}>
          <TextComponent className={styles.contentHeading} text={"Link"} />
          <TextComponent
            className={styles.contentText}
            text={state?.pasteLink ? state?.pasteLink : "htttp/exmaple.com"}
          />
        </div>
        <div className={styles.mediaCont}>
          <video
            controls
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              borderRadius: "10px",
            }}
          >
            <source
              src={require("../../../../assets/images/dummyVideo.mp4")}
              type={"video/mp4"}
            />
          </video>
          {/* {mediaType[0] == "image" ? (
            <img
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: "10px",
              }}
              src={URL.createObjectURL(state?.media?.originFileObj)}
            />
          ) : mediaType[0] == "video" ? (
            <video
              controls
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                borderRadius: "10px",
              }}
            >
              <source
                src={URL.createObjectURL(state?.media?.originFileObj)}
                type={state?.media?.type}
              />
            </video>
          ) : mediaType[0] == "application" ? (
            <div
            className={styles.documentDiv}
            
            >
              <DocViewer
                documents={[
                  {
                    uri: URL.createObjectURL(state?.media?.originFileObj),
                    fileType: state?.media?.type,
                    fileName: state?.media?.name,
                  },
                ]}
                config={{
                
                  pdfZoom: {
                    defaultZoom: 0.5, 
                    zoomJump: 0.2, 
                  },
                }}
                pluginRenderers={DocViewerRenderers}
                style={{
                  width: "100%",
                  height: "100%",
                  overflowY: "auto",
                }}
              />
            </div>
          ) : null} */}
        </div>
      </div>
    </div>
  );
};

export default StaffViewTraining;
